import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// Dates are stored as UTC midnight of the chosen day (YYYY-MM-DD sent from UI).
// Reading them back with dayjs.utc() gives the same calendar date regardless of
// the browser's local timezone.
const toDateKey = (date) => dayjs.utc(date).format("YYYY-MM-DD");
const todayUTC  = () => dayjs.utc().format("YYYY-MM-DD");

// Groups tasks by actualDeadlineDate.
// Tasks without a deadline are excluded (they appear in the NoDateStrip).
export function buildTaskMap(tasks) {
  const map = {};
  tasks.forEach((t) => {
    if (!t.actualDeadlineDate) return;
    const key = toDateKey(t.actualDeadlineDate);
    (map[key] = map[key] || []).push(t);
  });
  return map;
}

// Returns the UTC date key for a task, or null if no deadline is set.
export function taskDateKey(t) {
  return t.actualDeadlineDate ? toDateKey(t.actualDeadlineDate) : null;
}

// A task is overdue when its deadline is before today (UTC) and it is not completed.
export function isTaskOverdue(task) {
  if (!task.actualDeadlineDate) return false;
  if (task.status === 3) return false; // 3 = COMPLETED
  return toDateKey(task.actualDeadlineDate) < todayUTC();
}

// Builds a 42-cell (6-week) grid for the given month.
// Cells outside the current month have current = false.
export function buildGrid(month) {
  const first       = month.startOf("month");
  const startPad    = first.day(); // 0=Sun … 6=Sat
  const daysInMonth = month.daysInMonth();
  const cells       = [];

  for (let i = startPad - 1; i >= 0; i--)
    cells.push({ date: first.subtract(i + 1, "day"), current: false });

  for (let d = 0; d < daysInMonth; d++)
    cells.push({ date: first.add(d, "day"), current: true });

  const last      = month.endOf("month");
  const remaining = 42 - cells.length;
  for (let i = 1; i <= remaining; i++)
    cells.push({ date: last.add(i, "day"), current: false });

  return cells;
}

// Returns the display name for an assignee from either field the API may return.
export function getAssigneeName(task) {
  return (task.assigneeName || task.assigneeUserName || "").trim() || null;
}
